import { render, staticRenderFns } from "./InvoicesOverview.vue?vue&type=template&id=81dc06c8&scoped=true"
import script from "./InvoicesOverview.vue?vue&type=script&lang=js"
export * from "./InvoicesOverview.vue?vue&type=script&lang=js"
import style0 from "./InvoicesOverview.vue?vue&type=style&index=0&id=81dc06c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc06c8",
  null
  
)

export default component.exports